import React, {Component} from 'react';
import styles from "../GameTable.module.css";
import {withApplicationContext} from "../../../contexts/ApplicationContext"
import {withGameTableContext} from "../../../contexts/GameTableContext"
import classNames from "classnames";
import {RED_NUMBERS_OF_TABLE} from "../../../helpers/constants";
class TopCells extends Component {
    render() {
        const {gameTableContext} = this.props;
        const history = gameTableContext.state.numberHistory.slice(1);
        return (
            <div className={styles.BallHistory} role="list" aria-label="Previous roulette results"
                 style={{'--history-count': Math.max(1, history.length)}}>
                {history.map((number, index) => (
                    <div role="listitem" key={index}
                         className={classNames(styles.BallHistoryCell,
                             RED_NUMBERS_OF_TABLE.includes(number) && styles.CellRed,
                             number === 0 && styles.CellGreen)}>
                        {number}
                    </div>
                ))}
            </div>
        );
    }
}

export default withApplicationContext(withGameTableContext(TopCells));
